import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { ManufacturerCertificate } from '../check-order-manufacturer.models';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';
import { Observable } from 'rxjs';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';
import Swal from 'sweetalert2';
import { OrderProcessingService } from 'src/app/services/portal-supplier/order-processing.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-check-order-certificates',
  standalone: false,
  templateUrl: './check-order-certificates.component.html',
  styleUrls: ['./check-order-certificates.component.scss'],
})

export class CheckOrderCertificatesComponent implements OnInit, OnDestroy {
  @ViewChild('certificateFileInput')
  private certificateFileInput?: ElementRef<HTMLInputElement>;

  @Input({ required: true }) public certificates: ManufacturerCertificate[] = [];
  @Input()
  public batchToAddFileTo: Partial<ProcessingOrders.IProductBatch> | null =
    null;
  @Input() public productToWorkOn: ProcessingOrders.IProductInOrder | null =
    null;
  @Output() public readonly certificateRemoved = new EventEmitter<number>();
  @Output() public readonly certificateAdded = new EventEmitter<boolean>();

  private readonly orderServ = inject(OrderProcessingService);

  private orderService = inject(OrderHelperService);
  public mServ = inject(ManufacturerPopoversService);

  ngOnInit(): void {
    //this.orderService.selectedBatch.subscribe();
  }

  ngOnDestroy(): void { }

  public get getBatch(): Observable<ProcessingOrders.IProductBatchDocument[]> {
    return this.orderService.selectedDocuments.asObservable();
  }

  public async removeCertificate(code: number, event: Event) {
    event.stopPropagation();
    const isAllowed = await this.mServ.askForDocumentDelete();

    if (!isAllowed) return;
    this.certificateRemoved.emit(code);
  }

  public uploadCertificate(): void {
    this.certificateFileInput?.nativeElement.click();
  }

  public onCertificateSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    const batchInfo = this.batchToAddFileTo as
      | (Partial<ProcessingOrders.IProductBatch> & { result_id?: number })
      | null;

    const certificationBatchId =
      batchInfo?.supplier_certificate_batch_id;
    if (!certificationBatchId) {
      this.mServ.errorSwal('Batch non disponibile per il caricamento del certificato.');
      input.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const fileContent = reader.result?.toString() ?? '';
      const base64Content = fileContent.includes(',')
        ? fileContent.split(',')[1]
        : fileContent;

      const documentToAdd = {
        certification_batch_id: certificationBatchId,
        certification_file: base64Content,
        certification_title: file.name,
        certification_file_name: file.name,
      };

      this.orderServ.putCertificationFile(documentToAdd).subscribe({
        next: async (response) => {
          if (!response || response instanceof HttpErrorResponse) {
            this.mServ.errorSwal('Errore durante il caricamento del certificato.');
            return;
          }

          const requestSucceeded =
            !('success' in response) || response.success === true;

          if (!requestSucceeded) {
            this.mServ.errorSwal('Errore durante il caricamento del certificato.');
            return;
          }
          this.mServ.successSwal('Certificato caricato con successo.');
          this.certificateAdded.emit(true);

        },
        error: () => {
          this.mServ.errorSwal('Errore durante il caricamento del certificato.');
        },
      });
    };

    reader.onerror = () => {
      this.mServ.errorSwal('Impossibile leggere il file selezionato.');
    };

    reader.readAsDataURL(file);
    input.value = '';
  }

}
